import china from "./china.json";
import hebei from "./hebei.json";
import shanghai from "./shanghai.json";
import shanxi from "./shanxi.json";
import neimenggu from "./neimenggu.json";
import liaoning from "./liaoning.json";
import jilin from "./jilin.json";
import heilongjiang from "./heilongjiang.json";
import jiangsu from "./jiangsu.json";
import zhejiang from "./zhejiang.json";
import anhui from "./anhui.json";
import fujian from "./fujian.json";
import jiangxi from "./jiangxi.json";
import shandong from "./shandong.json";
import henan from "./henan.json";
import hubei from "./hubei.json";
import hunan from "./hunan.json";
import guangdong from "./guangdong.json";
import guangxi from "./guangxi.json";
import hainan from "./hainan.json";
import sichuan from "./sichuan.json";
import guizhou from "./guizhou.json";
import yunnan from "./yunnan.json";
import xizang from "./xizang.json";
import shanxi1 from "./shanxi1.json";
import gansu from "./gansu.json";
import qinghai from "./qinghai.json";
import ningxia from "./ningxia.json";
import xinjiang from "./xinjiang.json";
import beijing from "./beijing.json";
import tianjin from "./tianjin.json";
import chongqing from "./chongqing.json";

export const Map = {
  全国: china,
  上海: shanghai,
  河北: hebei,
  山西: shanxi,
  内蒙古: neimenggu,
  辽宁: liaoning,
  吉林: jilin,
  黑龙江: heilongjiang,
  江苏: jiangsu,
  浙江: zhejiang,
  安徽: anhui,
  福建: fujian,
  江西: jiangxi,
  山东: shandong,
  河南: henan,
  湖北: hubei,
  湖南: hunan,
  广东: guangdong,
  广西: guangxi,
  海南: hainan,
  四川: sichuan,
  贵州: guizhou,
  云南: yunnan,
  西藏: xizang,
  陕西: shanxi1,
  甘肃: gansu,
  青海: qinghai,
  宁夏: ningxia,
  新疆: xinjiang,
  北京: beijing,
  天津: tianjin,
  重庆: chongqing,
};
